import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useAppSelector } from "../../../store/hooks";

const QuestionDisplay = ({
  addStudentAnswer,
}: {
  addStudentAnswer: (answer: {
    studentId: number;
    studentName: string;
    answers: number[];
  }) => void;
}) => {
  const [selectedAnswers, setSelectedAnswers] = useState<number[]>([]);
  const { uid, user_display_name } = useAppSelector(
    (state) => state.store.user
  );
  const { studentsAnswers, question } = useAppSelector(
    (state) => state.liveSession
  );

  const isSingleAnswer =
    question.answers.filter((ans) => ans.isCorrect).length === 1;

  const isSubmitted =
    studentsAnswers?.find((ans) => ans.studentId === uid) || question.timeup;

  const handleAnswerClick = (answerId: number) => {
    if (isSubmitted) return;

    if (isSingleAnswer) {
      setSelectedAnswers([answerId]);
    } else {
      setSelectedAnswers((prev) =>
        prev.includes(answerId)
          ? prev.filter((id) => id !== answerId)
          : [...prev, answerId]
      );
    }
  };

  const handleSubmit = () => {
    addStudentAnswer({
      studentId: uid,
      studentName: Array.isArray(user_display_name?.split(" "))
        ? user_display_name?.split(" ").slice(0, 2).join(" ")
        : user_display_name,
      answers: selectedAnswers,
    });
  };

  return (
    <div
      className="flex flex-col items-center gap-2 p-2"
      style={{
        overflowY: "scroll",
      }}
    >
      <h4 className="text-center text-primary">أجب على السؤال</h4>
      {question.answers.map((answer) => {
        const isChosen = (
          studentsAnswers?.length > 0
            ? studentsAnswers.find((ans) => ans.studentId === uid)?.answers
            : selectedAnswers
        ).includes(answer.id);
        const isCorrect = answer.isCorrect;

        let styles = {};
        if (!question.timeup) {
          styles = {
            border: isChosen ? "1px solid darkgrey" : "1px solid lightgrey",
            backgroundColor: isChosen ? "lightgrey" : "white",
          };
        } else {
          if (isChosen && isCorrect) {
            styles = {
              border: "1px solid rgb(25, 135, 84)",
              backgroundColor: "rgb(25, 135, 84)",
              color: "white",
            };
          } else if (isChosen && !isCorrect) {
            styles = {
              border: "1px solid rgb(218, 22, 41)",
              backgroundColor: "rgb(218, 22, 41)",
              color: "white",
            };
          } else if (!isChosen && isCorrect) {
            styles = {
              border: "1px solid rgb(154 193 175)",
              backgroundColor: "rgb(209 231 222)",
            };
          } else {
            styles = {
              border: "1px solid lightgrey",
              backgroundColor: "white",
            };
          }
        }

        return (
          <div
            key={answer.id}
            style={{
              ...styles,
              padding: ".5rem 1rem",
              borderRadius: ".5rem",
              width: "100%",
              cursor: isSubmitted ? "not-allowed" : "pointer",
            }}
            onClick={() => handleAnswerClick(answer.id)}
          >
            {answer.text}
          </div>
        );
      })}
      <Button
        className="mt-3 w-full"
        style={{ maxHeight: "2.5rem" }}
        onClick={handleSubmit}
        disabled={!!isSubmitted}
      >
        إرسال الإجابة
      </Button>
    </div>
  );
};

export default QuestionDisplay;
